import { debounce } from 'debounce'
import moment from 'moment'
import i18n from '../i18n/i18n'
import queueToast from '@/helpers/queueToast'

const mixins = {
  props: {
    from: {
      type: Object,
      required: false,
    },
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent || navigator.vendor || window.opera
        )
      ) {
        return true
      }
      return false
    },
    today() {
      return moment().format('YYYY-MM-DD')
    },
    authUser() {
      return this.$store.state.auth.user
    },
    isAdmin() {
      let roles = this.$store.state.auth.roles

      let isAdmin = roles.some(
        (role) => role.confirm && role.roleId && role.roleId.type === 'all'
      )
      return isAdmin
    },
    isTrainer() {
      let roles = this.$store.state.auth.roles

      let isTrainer = roles.some(
        (role) => role.confirm && role.roleId && role.roleId.type === 'trainer'
      )
      return isTrainer
    },
  },
  methods: {
    is(type, objectId) {
      if (!type) return false
      if (this.isAdmin) return true
      let roles = this.$store.state.auth.roles

      let is = roles.some((role) => {
        let result = role.confirm && role.roleId
        if (result) {
          if (Array.isArray(type)) result = type.includes(role.roleId.type)
          else result = type === role.roleId.type

          if (objectId) result = result && role.objectId.includes(objectId)
        }
        return result
      })
      return is
    },
    async validate() {
      try {
        const result = await this.$validator.validateAll()
        if (result) return true

        let message = 'Error en validación, revisar formulario'
        queueToast([message])

        return false
      } catch (error) {
        return false
      }
    },
    nextTick(callback, timeout) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$nextTick(() => {
            setTimeout(() => callback(), timeout || 0)
          })
        })
      })
    },
    resetPagitations() {
      // let modules = [
      //   'countries',
      //   'provinces',
      //   'towns',
      //   'users',
      //   'roles',
      //   'entities',
      //   'teams',
      //   'stadiums',
      //   'pitches',
      //   'cameras',
      //   'categories',
      //   'matches',
      //   'tournaments'
      // ]
      // modules.forEach(item => this.$store.commit(`${item}/resetPagination`))
    },
    debounceFetch: debounce(function (model, params) {
      this.$store.dispatch(`${model}/fetchList`, params)
    }, 700),
    debounceFetchSelect: debounce(function (model, params) {
      this.$store.dispatch(`${model}/fetchSelectList`, params)
    }, 700),
    debounceUsers: debounce(function (params) {
      this.$store.dispatch('users/fetchSelectList', params)
    }, 700),
    debounceTeams: debounce(function (params) {
      this.$store.dispatch('teams/fetchSelectList', params)
    }, 700),
    debounceEntities: debounce(function (params) {
      this.$store.dispatch('entities/fetchSelectList', params)
    }, 700),
    debounceStadiums: debounce(function (params) {
      this.$store.dispatch('stadiums/fetchSelectList', params)
    }, 700),
    debouncePitches: debounce(function (params) {
      this.$store.dispatch('pitches/fetchSelectList', params)
    }, 700),
    hasPermission(webservice) {
      if (this.isAdmin) return true

      let roles = this.$store.state.auth.roles

      let hasPermission = roles.some(
        (role) =>
          role.confirm &&
          role.approved &&
          role.roleId &&
          role.roleId.permissions.some((p) => p === webservice)
      )
      return hasPermission
    },
    can(action, model, object) {
      try {
        if (!action || !model) return false
        if (object && typeof object !== 'object') return false
        if (object && !Object.keys(object).length) return false
        if (this.isAdmin || this.isCreator(object)) return true

        let ws = action.toUpperCase() + '_'
        ws +=
          action === 'list'
            ? i18n.tc(model, 2, 'en').toUpperCase()
            : model.toUpperCase()

        let roles = this.$store.state.auth.roles

        let hasPermission = roles.some((role) => {
          return (
            role.confirm &&
            role.roleId &&
            role.roleId.permissions &&
            role.roleId.permissions.some((permission) => {
              return (
                permission === ws ||
                (action === 'list' &&
                  permission === `LIST_${model.toUpperCase()}`)
              )
            })
          )
        })
        if (hasPermission) {
          if (
            action === 'create' ||
            action === 'list' ||
            action === 'download'
          ) {
            hasPermission = true // was aready like this
          } else if (object && object._id) {
            hasPermission = roles.some((role) => {
              if (!role.confirm || !role.roleId) return false
              let isValid = false

              // Permisos directos
              if (role.objectId.includes(object._id)) isValid = true
              else {
                // Permisos indirectos
                if (
                  model === 'team' &&
                  (role.roleId.type === 'president' ||
                    role.roleId.type === 'coordinator')
                ) {
                  isValid = role.objectId.includes(object.entityId)
                }

                if (!isValid && model === 'user') {
                  isValid = true
                }

                if (!isValid && model === 'tournament') {
                  isValid = role.objectId.includes(object._id)
                }

                if (model === 'match' || model === 'training') {
                  let teamIds = []
                  let entityIds = []

                  if (model === 'match') {
                    if (object.homeTeamId) teamIds.push(object.homeTeamId)
                    if (object.visitorTeamId) teamIds.push(object.visitorTeamId)
                    if (object.homeEntityId) entityIds.push(object.homeEntityId)
                    if (object.visitorEntityId)
                      entityIds.push(object.visitorEntityId)
                  } else if (model === 'training') {
                    if (object.teamId) teamIds.push(object.teamId)
                    if (object.entityId) entityIds.push(object.entityId)
                  }

                  if (role.roleId.type === 'trainer') {
                    if (role.objectId.some((id) => teamIds.includes(id))) {
                      isValid = true
                    }
                  } else if (
                    role.roleId.type === 'president' ||
                    role.roleId.type === 'coordinator'
                  ) {
                    if (role.objectId.some((id) => entityIds.includes(id))) {
                      isValid = true
                    }
                  }
                }
              }

              return isValid
            })
          }
        }

        return hasPermission
      } catch (error) {
        console.log(error)
        return false
      }
    },
    getName(item) {
      if (!item || !Array.isArray(item)) return item
      const iso = this.$store.state.languages.iso()
      let result = item.find((name) => name.iso === iso)
      if (!result) result = item.find((name) => name.iso === 'es-ES')
      return result ? result.text : ''
    },
    onImgError(ref) {
      this.$refs[ref].src = process.env.VUE_APP_IMAGE_URL + 'default-image.png'
    },
    isCreator(object) {
      let user = this.$store.state.auth.user
      if (!object || !user) return false
      if (object.createdById) return object.createdById === user._id
      else if (object.createdBy) {
        if (typeof object.createdBy === 'object') {
          return object.createdBy._id === user._id
        } else {
          return object.createdBy === user._id
        }
      }
      return false
    },
    removeDuplicated(list, value) {
      const removeDuplicated = (list = list.filter(
        (thing, index, self) =>
          index ===
          self.findIndex(
            (t) => t.place === thing.place && t[value] === thing[value]
          )
      ))
      return removeDuplicated
    },
  },
}

export default mixins
